import { GetStaticPropsContext, GetStaticPropsResult } from 'next'
import { FunctionComponent } from 'react'
import { FahrlehrerCh } from '@/src/@types/blinkadmin'
import { PageParams, PreviewData } from '@/src/@types/infrastructur'
import * as CourseLocation from '@/src/components/flch/pages/CourseLocation'
import * as Profile from '@/src/components/flch/pages/Profile'
import * as TeacherLocation from '@/src/components/flch/pages/TeacherLocation'

export type GenericPageBlueprint<Props> = {
  getStaticProps(
    context: GetStaticPropsContext<PageParams, PreviewData>,
    values:
      | FahrlehrerCh.TeacherProfile
      | FahrlehrerCh.LocationPage
      | FahrlehrerCh.CoursesPage
  ): Promise<GetStaticPropsResult<Props>>
  default: FunctionComponent<Props>
}

const dynamicPages: Record<string, GenericPageBlueprint<any>> = {
  teacher: Profile,
  'teacher-location': TeacherLocation,
  courses: CourseLocation,
}

export default function find<Name extends string>(dynamicPageName: Name) {
  const dynamicPage = dynamicPages[dynamicPageName]

  if (!dynamicPage) {
    return undefined
  }

  return { ...dynamicPage, name: dynamicPageName }
}
